/**
 * The backend gives employees created without an email a placeholder address
 * (`emp-…@employees.cashiero.local`, see users.service.ts). It is not a real mailbox, so the admin
 * never shows it and never asks the user to keep it.
 */
const GENERATED_EMPLOYEE_EMAIL_DOMAIN = "@employees.cashiero.local";

export function isGeneratedEmployeeEmail(email?: string | null): boolean {
	return !!email && email.trim().toLowerCase().endsWith(GENERATED_EMPLOYEE_EMAIL_DOMAIN);
}

/** The email to display or prefill: "" for generated placeholder addresses. */
export function visibleEmployeeEmail(email?: string | null): string {
	if (!email || isGeneratedEmployeeEmail(email)) return "";
	return email;
}
